import { createContext, useContext, type ReactNode } from 'react'

const FALLBACK_TOKEN = process.env.AUTH_COOKIE ?? 'abc123'

const TenantContext = createContext<string>(FALLBACK_TOKEN)

export const useTenantToken = () => useContext(TenantContext)

export const TenantProvider = ({
  token,
  children,
}: {
  token?: string | null
  children: ReactNode
}) => {
  const value = token && token.length > 0 ? token : FALLBACK_TOKEN
  return <TenantContext.Provider value={value}>{children}</TenantContext.Provider>
}
